function useInputState() {
  const hasErrors = (errorMessage: string) => errorMessage.length > 0;

  const getInputState = ({
    errorMessage,
    isSuccess,
  }: {
    errorMessage: string | undefined;
    isSuccess?: boolean;
  }) => {
    if (errorMessage && hasErrors(errorMessage)) {
      return 'error';
    }

    return isSuccess ? 'success' : 'info';
  };

  const getHelperMessage = ({
    errorMessage,
    infoMessage,
    successMessage,
  }: {
    errorMessage?: string;
    infoMessage?: string;
    successMessage?: string;
  }) => ({
    error: errorMessage && hasErrors(errorMessage) ? errorMessage : '',
    info: infoMessage ? infoMessage : '',
    success: successMessage ? successMessage : '',
  });

  return { getInputState, hasErrors, getHelperMessage };
}

export default useInputState;
